import styled from 'styled-components';

export const FormInputRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;

  & > div:not(:last-child) {
    margin-right: 10px;
  }

  & > div:not(:first-child) {
    margin-left: 10px;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: ${props => (props.noMargin ? 0 : props.error || props.help ? 30 : 25)}px;

  input {
    display: block;
    width: 100%;
  }
`;

export const InputStyled = styled.input`
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  background-clip: padding-box;
  margin: 0;

  margin-bottom: ${props => (props.error || props.help ? 10 : 0)}px;

  background-color: transparent;
  height: 38px;
  border: 1px solid
    ${props => (props.error ? props.theme.colors.danger : props.theme.colors.secondary80w)};
  border-radius: 10px;

  padding: 0 20px;

  font-family: ${props => props.theme.fonts.gtEesti};
  font-size: 16px;
  line-height: 18px;
  color: ${props => props.theme.colors.secondary};

  &::placeholder {
    opacity: 0.4;
    font-size: 14px;
  }

  &:disabled {
    background-color: ${props => props.theme.colors.secondary90w};
    &:hover {
      cursor: not-allowed;
    }
  }

  &:not(:disabled) {
    &:hover {
      border: 1px solid
        ${props => (props.error ? props.theme.colors.danger : props.theme.colors.black)};
    }
    &:focus {
      outline: none;
      background-color: ${props => props.theme.colors.white};
      border: 1px solid
        ${props => (props.error ? props.theme.colors.danger : props.theme.colors.black)};
      box-shadow: 0 0 0 2px ${props => props.theme.colors.white},
        0 0 0 3px ${props => props.theme.colors.primary};
    }
  }
`;
